import client from './client';

export const getNotificationPrefs    = ()     => client.get('/api/users/me/notifications');
export const updateNotificationPrefs = (data) => client.put('/api/users/me/notifications', data);
